/**
 * The five risk bands, in one place.
 *
 * The keys are the model's own — `risk_matrix.py` emits Spanish band names and
 * every delivered report prints them, so translating them at the boundary would
 * mean the dashboard and the report disagreed about what a band is called in
 * the data. The labels are what the UI shows, because the UI is English.
 *
 * Fills match .risk-cell-* in report_styles.css: a reader who knows the report's
 * heat map should recognise this one without being taught it.
 */

export const BANDS = ['CRÍTICO', 'ALTO', 'MEDIO', 'BAJO', 'INFORMATIVO'];

export const BAND_FILL = {
  'CRÍTICO': '#dc2626',
  'ALTO': '#f97316',
  'MEDIO': '#facc15',
  'BAJO': '#60a5fa',
  'INFORMATIVO': '#93c5fd',
};

export const BAND_LABEL = {
  'CRÍTICO': 'Critical',
  'ALTO': 'High',
  'MEDIO': 'Medium',
  'BAJO': 'Low',
  'INFORMATIVO': 'Informational',
};

// Yellow and pale blue need dark text to stay legible.
export const BAND_TEXT = {
  'MEDIO': '#1a1a1a',
  'INFORMATIVO': '#1a1a1a',
};

/**
 * The band a 1–25 score falls in.
 *
 * Read off RIESGO_MATRIX rather than invented: every product reachable in that
 * table maps to exactly one band regardless of which exposure × impact pair
 * produced it, so these cut points reproduce the matrix rather than approximate
 * it. Used only for a *mean*, which is not itself a cell — an individual
 * finding's band always comes from the server, which does the real lookup.
 */
export function bandForScore(score) {
  if (score >= 20) return 'CRÍTICO';     // 20, 25
  if (score >= 15) return 'ALTO';        // 15, 16
  if (score >= 8) return 'MEDIO';        // 8, 9, 10, 12
  if (score >= 3) return 'BAJO';         // 3, 4, 5, 6
  return 'INFORMATIVO';                  // 1, 2
}
